import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDefectZandloperXl = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d='M18.8501 2.61011C18.8501 2.89011 18.6301 3.11011 18.3501 3.11011H5.64014C5.36014 3.11011 5.14014 2.89011 5.14014 2.61011C5.14014 2.33011 5.36014 2.11011 5.64014 2.11011H18.3501C18.6301 2.11011 18.8501 2.33011 18.8501 2.61011Z' />
    <path d='M18.8501 21.3901C18.8501 21.6701 18.6301 21.8901 18.3501 21.8901H5.64014C5.36014 21.8901 5.14014 21.6701 5.14014 21.3901C5.14014 21.1101 5.36014 20.8901 5.64014 20.8901H18.3501C18.6301 20.8901 18.8501 21.1101 18.8501 21.3901Z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M6.47014 18.8901C6.47014 19.1701 6.69014 19.3901 6.97014 19.3901H17.0201V19.3801C17.3001 19.3801 17.5201 19.1601 17.5201 18.8801V15.9501C17.5201 15.1101 17.0701 14.3301 16.3401 13.9101L13.0001 11.9901L16.3401 10.0701C17.0701 9.65011 17.5201 8.87011 17.5201 8.03011V5.10011C17.5201 4.82011 17.3001 4.60011 17.0201 4.60011H6.97014C6.69014 4.60011 6.47014 4.82011 6.47014 5.10011V8.03011C6.47014 8.87011 6.92014 9.65011 7.65014 10.0701L9.96014 11.4001L10.9701 10.8301L8.15014 9.21011C7.73014 8.97011 7.47014 8.52011 7.47014 8.04011V5.61011H16.5201V8.04011C16.5201 8.52011 16.2601 8.97011 15.8401 9.21011L7.65014 13.9201C6.92014 14.3401 6.47014 15.1201 6.47014 15.9601V18.8901ZM15.8401 14.7901C16.2601 15.0301 16.5201 15.4801 16.5201 15.9601V18.3901H7.46014V15.9601C7.46014 15.4801 7.72014 15.0301 8.14014 14.7901L11.9901 12.5801L15.8401 14.7901Z'
    />
  </svg>
);
export default SvgDefectZandloperXl;
